export const comprometimentoStatus = {
    EM_INDISPONIVEL: -1,
    EM_ABERTO: 0,
    EM_ANALISE: 1,
    APROVADO: 2,
    REPROVADO: 3
}
